import React, { PropsWithChildren, ReactNode, useEffect, useState } from 'react';
import { usePopper } from 'react-popper';
import useScrollPosition from '../../../lib/hooks/useScrollPosition';

interface HoverOverInfoProps {
  text: string | ReactNode;
  textClass: string;
  borderClass: string;
}
const TABLET = 768;

const HoverOverInfo:  React.FC<PropsWithChildren<HoverOverInfoProps>> = ({
  text,
  textClass,
  borderClass,
  children,
}) => {
  const [showPopper, setShowPopper] = useState(false);
  const [buttonRef, setButtonRef] = useState<HTMLButtonElement | null>(null);
  const { scrollPosition, innerWidth } = useScrollPosition();
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(
    null,
  );
  const { styles, attributes } = usePopper(buttonRef, popperElement, {
    placement: 'top',
    strategy: 'fixed',

    modifiers: [{
      name: 'preventOverflow', enabled: true
    }]

  });
  const handleEvent = (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | React.FocusEvent<HTMLButtonElement> | React.TouchEvent<HTMLButtonElement>, showPopper: boolean) => {
    event.preventDefault()
    event.stopPropagation();
    setShowPopper(showPopper)
  };

  useEffect(() => {
    if (showPopper && innerWidth <= TABLET) {
      setShowPopper(false);
    }
  }, [scrollPosition, innerWidth])

  return (
    <>
      <button
        ref={setButtonRef}
        onMouseOut={(event) => handleEvent(event, false)}
        onMouseOver={(event) => handleEvent(event, true)}
        onFocus={(event) => handleEvent(event, true)}
        onClick={(event) => handleEvent(event, true)}
        onTouchStart={(event) => handleEvent(event, true)}
        onBlur={(event) => handleEvent(event, false)}
        className={`tracking-normal text-left border-dashed cursor-pointer ${textClass} ${borderClass} border-b-1 peer`}
      >
        {text}
      </button>

      {showPopper && (
        <div
          className="z-100"
          ref={setPopperElement}
          style={styles.popper}
          {...attributes.popper}
        >
          {children}
        </div>
      )}
    </>
  );
};

export default HoverOverInfo;
